import useIsLoggedIn from "./useIsLoggedIn";
import { WebPaths } from "../routes/data";
import { ProfileSections } from "../views/web/profile/components/types";

const useNavigateToFibiVoice = () => {
  const isLoggedIn = useIsLoggedIn();

  return {
    url: isLoggedIn
      ? `${WebPaths.Profile}?active=${ProfileSections.fibiAi}`
      : WebPaths.Auth,
  };
};

export default useNavigateToFibiVoice;
